import { AVAILABLE_BONUSES } from 'common/constants/bonus.constants';
import { getI18n } from 'react-i18next';
import { log } from './logging.util';
import { IS_DISONA } from './style.util';

const DISONA_BONUS_NAME_TO_TYPE = {
  Welcome: '386f21da-b985-494c-91fb-6de751ca7cdd',
  TradesCount: '4fae112e-c0f7-47a1-be2c-a614c053f403',
  Volume: 'f0cf6645-cfdc-410c-bf36-4d84f6d7e695',
  Coupon: 'bdb93a6d-435b-4721-9a4b-15dd8520b4a4',
};

export const BONUS_NAME_TO_TYPE = IS_DISONA
  ? DISONA_BONUS_NAME_TO_TYPE
  : {
      Welcome: '0f64284c-fa10-4813-ac2c-45303b16a536',
      TradesCount: '43b9c409-150c-40c2-8b2b-76907177a8be',
      Volume: 'acbdfabb-df7f-4510-b0ec-b04b904fed1a',
      Coupon: '74d65db6-8d7e-46bd-b452-67c0da8a656d',
    };

export const INITIAL_BONUS_IDS_LIST = [
  BONUS_NAME_TO_TYPE.Welcome,
  BONUS_NAME_TO_TYPE.TradesCount,
];

const getBonusNameByType = (type) => {
  const foundBonus = Object.entries(BONUS_NAME_TO_TYPE).find(
    ([, value]) => value === type
  );
  if (!foundBonus) return null;
  return foundBonus[0];
};

const BONUS_TYPE_TO_FIELDS = {
  [BONUS_NAME_TO_TYPE.Welcome]: [
    'tab',
    'heading',
    'description',
    'rule1.heading',
    'rule1.body',
    'rule2.heading',
    'rule2.body',
    'rule3.heading',
    'rule3.body',
  ],
  [BONUS_NAME_TO_TYPE.TradesCount]: ['tab', 'heading', 'description'],
};

const getBonusDescription = (bonusType) => {
  const i18n = getI18n();
  const bonus = BONUS_TYPE_TO_FIELDS[bonusType];
  if (!bonus) {
    log(`unknown bonus ${bonusType}`, 'error');
    return null;
  }
  return Object.fromEntries(
    bonus.map((field) => [field, i18n.t(`bonuses.types.${bonusType}.${field}`)])
  );
};

const DETAILS_KEYS = {
  GO_TO_PROFILE: 'GO_TO_PROFILE',
  MAKE_DEPOSIT: 'MAKE_DEPOSIT',
  ACTIVATE: 'ACTIVATE',
};

const getBonusDetailsKey = ({ balance, needInfo, hasReadyRealAccount }) => {
  if (needInfo || !hasReadyRealAccount) return DETAILS_KEYS.GO_TO_PROFILE;
  if (balance) return DETAILS_KEYS.MAKE_DEPOSIT;
  return DETAILS_KEYS.ACTIVATE;
};

export const getSortBonusFn = (resolveGuid) => (a, b) =>
  AVAILABLE_BONUSES.indexOf(resolveGuid(a)) -
  AVAILABLE_BONUSES.indexOf(resolveGuid(b));

const sortByGuids = (sortData) => sortData.sort(getSortBonusFn((guid) => guid));

const getTimeFrame = (seconds, t) => {
  const hours = seconds / 3600;
  if (hours < 24) {
    return `${hours} ${t('hours')}`;
  }
  if (hours === 24) {
    return `1 ${t('day')}`;
  }
  if (hours / 24 === 7) {
    return `1 ${t('week')}`;
  }
  return `${Math.floor(hours / 24)} ${t('days')}`;
};

export const BonusUtils = {
  getBonusDescription,
  getBonusNameByType,
  DETAILS_KEYS,
  getBonusDetailsKey,
  sortByGuids,
  getTimeFrame,
};
